import React from 'react';
import { useSelector } from 'react-redux';
import { empty } from '../helpers/untils';

import PositionsMap from './PositionsMap';

const CurrentPositionsMap = (props) => {
  const { temporaryPage, currentLink, loadLinkInfo, showPaypalCreditLogsPage, commands, enablePopup = true, isTest = false } = props;
  const devices = useSelector((state) => Object.values(state.devices.items));

  return (
    <>
      {
        (!empty(devices)) ? (
          <>
            <PositionsMap
              devices={devices}
              temporaryPage={temporaryPage}
              currentLink={currentLink}
              loadLinkInfo={loadLinkInfo}
              showPaypalCreditLogsPage={showPaypalCreditLogsPage}
              commands={commands}
              enablePopup={enablePopup}
              isTest={isTest}
            />
          </>
        ) : (
          <></>
        )
      }
    </>
  );
};

export default CurrentPositionsMap;
